var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLectures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6344ae;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.44,116.972c23.206,0,42.007-18.817,42.007-42.008c0-23.215-18.801-42.016-42.007-42.016 c-23.216,0-42.016,18.801-42.016,42.016C39.424,98.155,58.224,116.972,81.44,116.972z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.166,245.037c0-0.856-0.142-1.673-0.251-2.498l62.748-45.541c3.942-2.867,4.83-8.411,1.963-12.362 c-1.664-2.285-4.342-3.652-7.17-3.652c-1.877,0-3.667,0.589-5.191,1.689l-62.873,45.636c-2.341-1.068-4.909-1.704-7.65-1.704 h-34.178l-8.294-47.222c-4.555-23.811-14.112-42.51-34.468-42.51h-86.3C22.146,136.873,0,159.019,0,179.383v141.203 c0,10.178,8.246,18.432,18.424,18.432c5.011,0,0,0,12.864,0l7.005,120.424c0,10.83,8.788,19.61,19.618,19.61 c8.12,0,28.398,0,39.227,0c10.83,0,19.61-8.78,19.61-19.61l9.204-238.53h0.463l5.27,23.269c1.743,11.097,11.293,19.28,22.524,19.28 h51.534C215.92,263.461,224.166,255.215,224.166,245.037z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "190.326,47.47 190.326,200.869 214.452,200.869 214.452,71.595 487.874,71.595 487.874,302.131  214.452,302.131 214.452,273.113 190.326,273.113 190.326,326.256 512,326.256 512,47.47  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.716,145.464l61.46,21.699v-65.238C341.762,101.925,317.661,120.129,308.716,145.464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.03,205.629c0,36.032,29.206,65.23,65.23,65.23c36.032,0,65.23-29.198,65.23-65.23 c0-36.015-29.198-65.222-65.23-65.222v65.222l-61.468-21.683C331.404,190.731,330.03,198.011,330.03,205.629z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLectures);
export default __webpack_public_path__ + "static/media/lectures.74d161df8c27b53ea14836c707aa60a5.svg";
export { ForwardRef as ReactComponent };